var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{ref:"input",attrs:{"placeholder":_vm.placeholder,"parse":_vm.parse,"search":_vm.search,"min-characters":3,"is-loading":_vm.loading,"caret":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }